"use client";

import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useMemo, useState } from "react";
import { getAllServices } from "@/lib/data";
import Link from "next/link";

export default function SolutionsAccordion({ controller }: { controller: () => void }) {
  const services = useMemo(
    () =>
      getAllServices().map(({ slug, name }) => ({
        slug,
        name,
      })),
    []
  );
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full">
      <button
        className="flex justify-center items-center gap-2 text-white w-full"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Services menu"
        aria-expanded={open}
        type="button"
      >
        <span className="font-semibold">Services</span>
        <ChevronDownIcon
          className={`transition-transform duration-200 ${open ? "rotate-0" : "-rotate-90"}`}
          width={20}
          height={20}
          aria-hidden="true"
        />
      </button>
      <div
        className={`text-center flex flex-col gap-3 overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          open ? "max-h-96 mt-5" : "max-h-0"
        }`}
      >
        <div className="flex flex-col gap-3">
          {services.map((service) => (
            <Link
              href={`/services/${service.slug}`}
              onClick={controller}
              className="whitespace-nowrap text-lg text-neutral-400 hover:text-yellow transition-colors"
              key={service.slug}
            >
              {service.name}
            </Link>
          ))}

          <Link
            href="/broward-county-services"
            onClick={controller}
            className="whitespace-nowrap text-sm text-yellow font-semibold mt-4 pt-2 border-t border-border"
          >
            View All Services by City →
          </Link>
        </div>
      </div>
    </div>
  );
}
